/**
 * Глобально отключает автозаполнение браузера для всех полей ввода.
 * MutationObserver ловит любой <input>/<textarea>/<select>,
 * включая динамически создаваемые компонентами Vuetify и сторонними библиотеками.
 */

const INPUT_SELECTORS = 'input, textarea, select'

/** Устанавливает autocomplete=off на элемент и все его дочерние поля ввода. */
const disableOn = (el: Element): void => {
  const tag = el.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
    el.setAttribute('autocomplete', 'off')
  }
  el.querySelectorAll?.(INPUT_SELECTORS).forEach((input) => {
    input.setAttribute('autocomplete', 'off')
  })
}

/** Проход по всем существующим полям + запуск наблюдателя за новыми. */
export const installDisableAutocomplete = (): void => {
  document.querySelectorAll(INPUT_SELECTORS).forEach((el) => {
    el.setAttribute('autocomplete', 'off')
  })

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) disableOn(node)
      })
    }
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
